import { useEffect, useState } from "react"
import { api } from "../system/api.js"
import { useNavigate } from "react-router-dom"
import { clearSessionStorage } from "../system/session.js"

export default function SignOut() {

  const [error, setError] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    api('sign/out').then(() => {
      clearSessionStorage()
      navigate('/sign/in')
    }).catch(() => {
      setError('An error occurred. Please try again.')
    })

  }, [navigate])

  return (
    <div>
      {/* <h1>Sign Out</h1> */}
      {error && <div>{error}</div>}
    </div>
  )
}
